import { ActivePayload, HoverPayload } from '../types'
import { CUSTOM_UNITS } from './chartModel'

/* Extracts the Y max value from the left y axis of the chart */
const getLeftYAxisMaxValue = (): number => {
  const yAxisWrapper = document.querySelectorAll('.recharts-layer.recharts-cartesian-axis.recharts-yAxis.yAxis')[0]
  const ticksWrapper = yAxisWrapper?.children[1]
  const tick = ticksWrapper?.children[ticksWrapper?.children.length - 1]
  const tickValue = tick?.children[1]?.children[0]?.innerHTML
  const yMaxValue = Number(tickValue?.split('W')[0]?.trim())

  return yMaxValue
}

/* Gets the cartesian grid height of the line chart */
const getCartesianGridHeight = (): number => {
  const element = document.querySelectorAll('.recharts-cartesian-grid')[0]
  const cartesianGridHeight = element?.getBoundingClientRect?.().height

  return cartesianGridHeight
}

/* Generates cx and cy values for the indicator line dots  */
const getCircleCoordinates = (
  payload: ActivePayload,
  hoverPayload: HoverPayload,
  cartesianGridHeight: number,
  leftYAxisMaxValue: number
): {
  cxValue: number
  cyValue: number
} => {
  const circleRadius = 6

  const value = Math.floor(payload?.value || 0)
  const isRightYAxisId = CUSTOM_UNITS.includes(payload.unit) // ? to understand why check LineChart.tsx and find the "lineProps" logic
  const yMaxValue = isRightYAxisId ? 100 : leftYAxisMaxValue // ? right y axis is percentage and the maximum value is 100%

  const cxValue = hoverPayload?.activeCoordinate?.x || 0
  const cyValue = getCyValue(value, circleRadius, cartesianGridHeight, yMaxValue, isRightYAxisId)

  return { cxValue, cyValue }
}

const getCyValue = (value: number, circleRadius: number, cartesianGridHeight: number, yMaxValue: number, isRightYAxisId: boolean): number => {
  const valuePercentage = (value / yMaxValue) * 100
  const cyValue = cartesianGridHeight - (value * cartesianGridHeight) / yMaxValue + circleRadius

  if (isRightYAxisId) return adjustValueForRightYAxis(cyValue, valuePercentage)
  return adjustValueForLeftYAxis(cyValue, valuePercentage)
}

/* These are some arbitrary values that were needed to make the circle position look correct */
const adjustValueForLeftYAxis = (cyValue: number, valuePercentage: number): number => {
  const NINETY_PERCENT_OFFSET = 7
  const SEVENTY_PERCENT_OFFSET = 5

  if (valuePercentage > 90) cyValue += NINETY_PERCENT_OFFSET
  else if (valuePercentage > 70) cyValue += SEVENTY_PERCENT_OFFSET

  return cyValue
}

/* These are some arbitrary values that were needed to make the circle position look correct */
const adjustValueForRightYAxis = (cyValue: number, valuePercentage: number): number => {
  const THIRTY_PERCENT_OFFSET = -2
  const TWENTY_PERCENT_OFFSET = -5
  const ONE_PERCENT_OFFSET = -2

  if (valuePercentage > 30) cyValue += THIRTY_PERCENT_OFFSET
  else if (valuePercentage > 20) cyValue += TWENTY_PERCENT_OFFSET
  else if (valuePercentage > 1) cyValue += ONE_PERCENT_OFFSET

  return cyValue
}

export { getCircleCoordinates, getLeftYAxisMaxValue, getCartesianGridHeight }
